// El estado de una persona del staff EN ESTE CLUB y lo que la pantalla de Staff le ofrece. Reglas puras (sin red), sobre una fila
// de get_org_staff (20261031_cada_org_su_staff): status y rol son de la membresia con el club; activo es staff.activo (global:
// lo apaga MYKLUBB); en_otra_org dice si tambien tiene membresia activa en otra organizacion (su correo y su acceso son de MYKLUBB).

export const ESTADOS_STAFF = ['activo', 'baja', 'desactivado']

export const ETIQUETA_ESTADO = {
  activo: 'En el club',
  baja: 'De baja',
  desactivado: 'Cuenta desactivada',
}

export const MENSAJE_CORREO_OTRA_ORG = 'Solo MYKLUBB puede cambiar el correo de quien también está en otra organización.'
export const MENSAJE_REACTIVAR_OTRA_ORG = 'Solo MYKLUBB puede reactivar a esta persona.'
export const MENSAJE_SIN_FILA = 'Esta persona ya no es parte del club; usa "Reactivar" para editar sus datos.'

/**
 * 'baja' si la membresia con el club no esta activa; si no, 'desactivado' solo si staff.activo es false (undefined o null cuentan
 * como cuenta activa: una columna que no llega no apaga a nadie); si no, 'activo'.
 */
export function estadoStaff(m) {
  if (!m || m.status !== 'active') return 'baja'
  if (m.activo === false) return 'desactivado'
  return 'activo'
}

/**
 * Lo que la pantalla ofrece sobre una fila. `soloMyklubb`: la persona esta activa en otra org y quien mira no es Platform Admin.
 * `fundadorAqui`: la persona fundadora, en la org que fundo (su principal: es_principal; si no llega, se toma como principal). La
 * base solo la protege ahi (_protect_founder_membership, protect_founder_admin); en otra org es miembro como cualquiera.
 * `fundadorBloqueado`: fundadorAqui y quien mira no es Platform Admin (el Platform Admin si la da de baja: la base lo deja).
 * `esYo`: la fila es la de la sesion; su correo es suyo aunque este en otra org (la Edge y el trigger la exceptuan).
 */
export function accionesStaff(m, { isPlatformAdmin = false, esYo = false } = {}) {
  const estado = estadoStaff(m)
  const soloMyklubb = Boolean(m?.en_otra_org) && !isPlatformAdmin
  const fundadorAqui = Boolean(m?.is_founder) && m?.es_principal !== false
  const fundadorBloqueado = fundadorAqui && !isPlatformAdmin
  const conAcceso = Boolean(m?.usuario_creado)
  const correoTemporal = String(m?.email || '').includes('@temp.com')
  const miembro = estado !== 'baja'

  return {
    estado,
    soloMyklubb,
    fundadorAqui,
    fundadorBloqueado,
    // Primaria segun el estado: reactivar (baja o desactivado) o crear el acceso que falta.
    reactivarMembresia: estado === 'baja',
    reactivarEnMyklubb: estado === 'desactivado' && !soloMyklubb,
    reactivarSoloMyklubb: estado === 'desactivado' && soloMyklubb,
    crearAcceso: estado === 'activo' && !conAcceso && !correoTemporal,
    // Sin membresia activa la base ya no deja editar su ficha.
    editar: miembro,
    cambiarFoto: miembro,
    correoEditable: miembro && (!soloMyklubb || esYo),
    reenviarInvitacion: miembro && conAcceso,
    // Quien fundo la org no se da de baja ahi (salvo con el Platform Admin); nadie se da de baja a si (se quedaria fuera).
    darDeBaja: miembro && !fundadorBloqueado && !esYo,
    // update-staff-role no cambia el rol de quien fundo la org, ahi, ni con el Platform Admin (409).
    cambiarRol: estado === 'activo' && conAcceso && !fundadorAqui,
  }
}

/** Filtro de estado de la lista: 'todos' o uno de ESTADOS_STAFF. */
export function coincideEstado(m, filtro) {
  return filtro === 'todos' || estadoStaff(m) === filtro
}
